export default "__VITE_ASSET__CbGGdta9__"